class CityService {
    getCity() {
        return typeof window !== "undefined" && JSON.parse(localStorage.getItem("city"));
    }
    setCity(city) {
        localStorage.setItem("city", JSON.stringify(city));
    }
    removeCity() {
        localStorage.removeItem("city");
    }
}
export default new CityService();